import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

/**
 * Returns `null` when the level is not recorded, so callers can tell an empty
 * tank (fraction 0) apart from a missing reading.
 */
export function getLevelFraction(value: number | Nullish, min: number, max: number): number | null {
  if (isNil(value) || max === min) {
    return null;
  }

  return Math.min(1, Math.max(0, (value - min) / (max - min)));
}
